export default {
    registerContactBegin(state) {
        state.loading = true;
    },

    registerContactSuccess(state) {
        state.loading = false;
    },

    registerContactErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    readFormByTokenBegin(state) {
        state.loading = true;
    },

    readFormByTokenSuccess(state, data) {
        state.loading = false;
        state.data = data;
    },

    readFormByTokenErr(state, err) {
        state.loading = false;
        state.error = err;
    },
}